import React, {useEffect} from 'react';

import Box from "@mui/material/Box";
import { Table, TableBody, TableCell, TableRow } from "@mui/material";

import "../App.css"
import {useAppCtx} from "../app/AppCtx";
import {useCodeCtx} from "../app/CodeCtx"
import {useCrewCtx} from "../app/CrewCtx"
import {PageHeader} from "./PageHeader";

import {CxGrid} from "../cmx/CxGrid";
import {CxText} from "../cmx/CxTypography";

// ----------------------------------------------------------------------------------------------------------------
// Home
// ----------------------------------------------------------------------------------------------------------------

export function Home() {
    const {user} = useAppCtx();
    const {lazyloadCodes} = useCodeCtx();
    const {lazyloadCrews} = useCrewCtx();

    useEffect(() => {
        lazyloadCodes();
        lazyloadCrews();
    }, []);

    const title = `Willkommen ${user.firstname}`;

    const UserInfo = ({ user }) => {
        const rows = [
            { label: "Benutzername",    value: user.login_name },
            { label: "Vorname",         value: user.firstname },
            { label: "Nachname",        value: user.lastname },
            { label: "Adresse",         value: user.address },
            { label: "PLZ",             value: user.zip },
            { label: "Ort",             value: user.city },
            { label: "E-Mail",          value: user.email },
            { label: "Telefon",         value: user.phone },
            { label: "Telefon P",       value: user.private_phone },
            { label: "Id",              value: user.id },
        ];

        return (
            <Table size="small" sx={{ width: "auto" }}>
                <TableBody>
                    {rows.map((row, index) => (
                        <TableRow key={index}>
                            <TableCell sx={{ fontWeight: "bold" }}>{row.label}</TableCell>
                            <TableCell>{row.value || "-"}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        );
    };

    return (
        <Box sx={{ width: '100%' }}>
            <CxGrid container spacing={2}>
                <PageHeader title={title} />
                <CxGrid size="xl">
                    <CxText>Folgende Daten sind im System hinterlegt:</CxText>
                </CxGrid>
                <CxGrid size="xl">
                    { UserInfo({user}) }
                </CxGrid>
                <CxGrid size="xl">
                    <CxText>Sollte eine Angabe nicht stimmen, bitte dem Büro melden.</CxText>
                    <CxText>Vielen Dank</CxText>
                </CxGrid>
            </CxGrid>
        </Box>
    );
}

// --------------------------------------------------------------------------------------------------------------------
// The end.